import viewBusinessDetailsTypes from "./viewBusiness.types";

export const viewBusinessDetailsStart = (data: any) => ({
  type: viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_START,
  payload: data,
});

export const viewBusinessDetailsSuccess = (data: any) => ({
  type: viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_SUCCESS,
  payload: data,
});

export const viewBusinessDetailsFailure = (error: any) => ({
  type: viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_FAILURE,
  payload: error,
});

export const viewBusinessDetailsChanged = () => ({
  type: viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_CHANGED,
});
export const viewBusinessDetailsReset = () => ({
  type: viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_RESET,
});
